import { useState, useEffect, useCallback } from 'react';
import { quikqApiService, QuikQUserProfile } from '../services/quikqApi';

export const useUserProfile = () => {
  const [userProfile, setUserProfile] = useState<QuikQUserProfile | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchUserProfile = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      
      const profile = await quikqApiService.getUserProfile();
      setUserProfile(profile);
    } catch (err) {
      console.error('Error fetching user profile:', err);
      setError('Error loading user profile data.');
    } finally {
      setLoading(false);
    }
  }, []);

  const updateUserProfile = useCallback(async (profileData: Partial<QuikQUserProfile>) => {
    try {
      setLoading(true);
      setError(null);
      
      const updatedProfile = await quikqApiService.updateUserProfile(profileData);
      setUserProfile(updatedProfile);
      return updatedProfile;
    } catch (err) {
      console.error('Error updating user profile:', err);
      setError('Error saving user profile data.');
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchUserProfile();
  }, [fetchUserProfile]);

  return {
    userProfile,
    loading,
    error,
    fetchUserProfile,
    updateUserProfile,
  };
}; 